<template>
  <!-- 自定义class名称
       @author: 王汝鹏
       @date: 2019-9-16
   -->
  <div class="setting-item">
    <el-form-item label="自定义类名"> 
      <el-input v-model="customClass"
                placeholder="请输入自定义类名"></el-input>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 自定义class名称
     *  @description 将 customClass 字段映射到当前 customClass 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-16
     */
    ...mapComputed({
      customClass: { 
        parent: i => i.styleOption,
        attr: "customClass",
      }
    }),
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/style_setting/SettingStyleClass.vue